import React from 'react'
import { titleCase } from 'change-case'
import { TextWithOverflowTooltip } from '../../../components/TextWithOverflowTooltip'

interface Props {
  error: object
}
const ListingErrorWithOverflowTooltip: React.FC<Props> = ({ error }): JSX.Element | null => {
  if (!error) return null
  return (
    <>
      {Object.keys(error).map(err => {
        // A generic `errors` key carries no information (unlike channel-specific
        // error codes), so show the message on its own without a redundant label.
        const label = err === 'errors' ? `${error[err]}` : `${titleCase(err)}  ${error[err]}`
        return (
          <div key={err}>
            <TextWithOverflowTooltip label={label} tooltipContent={label} />
          </div>
        )
      })}
    </>
  )
}
export default ListingErrorWithOverflowTooltip
